// extracted by mini-css-extract-plugin
export default {"rodo":"Rodo_rodo__pYtRq","rodoHead":"Rodo_rodoHead__yiDOE","rodoBody":"Rodo_rodoBody__cgNpK"};